export function formatPositivePoints(points: number): string {
	return points.toLocaleString('de-DE');
}

export function formatPointsWithSign(points: number): string {
	const formattedPoints = Math.abs(points).toLocaleString('de-DE');
	return points >= 0 ? `+ ${formattedPoints}` : `- ${formattedPoints}`;
}

export function formatPoints(points: number): string {
	return Math.abs(points).toLocaleString('de-DE');
}

export function appendPrebookedInfo(points: number): string {
	const pointsWithSuffix = appendPointsWord(points);
	return `+${pointsWithSuffix} vorgemerkt`;
}

export function appendPointsWord(points: number) {
	const suffix = getPointsWord(points);
	return `${formatPositivePoints(points)} ${suffix}`;
}

export function getPointsWord(points: number) {
	return points.toString() === '1' ? 'Punkt' : 'Punkte';
}

export function appendBonusPointsWord(points: number) {
	const suffix = getBonusPointsWord(points);
	return `${formatPositivePoints(points)} ${suffix}`;
}

function getBonusPointsWord(points: number) {
	return points.toString() === '1' ? 'Bonus-Punkt' : 'Bonus-Punkte';
}

export function formatLevelPointsWithWording(points: number) {
	const suffix = getLevelPointsWord(points);
	return `${formatPositivePoints(points)} ${suffix}`;
}

function getLevelPointsWord(points: number) {
	return points.toString() === '1' ? 'Level-Punkt' : 'Level-Punkte';
}
